module.exports = __webpack_public_path__ + "img/george-washington.1cf62c38.png";